import { ErrorHandler, Injectable } from "@angular/core";
import { MyMonitoringService } from "./logging.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private monitoringService: MyMonitoringService) {
        super();
    }

    override handleError(error: Error) {
        console.error("HIDDEN ERROR:", error);
        this.monitoringService.logException(error); // Manually log exception
    }
}